module.exports = __webpack_public_path__ + "static/img/zanting2.88c4868.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/zanting2.png
// module id = x1Nz
// module chunks = 24